import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CreateNotification, GetAllNotificationsForUserFilter, GetNotificationsCreatedByUserFilter, GetUnreadNotificationsForUserFilter, MarkNotificationAsDelivered, NotificationCreatedByUser, NotificationForUser, UnreadNotificationForUser } from '../models/notification';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private baseUrl = `${environment.apiUrl}/notifications`; // Backend API for notifications

  constructor(private http: HttpClient) {}

  createNotification(notification: CreateNotification): Observable<void> {
    return this.http.post<void>(this.baseUrl, notification);
  }

  markNotificationAsDelivered(markNotificationAsDelivered: MarkNotificationAsDelivered): Observable<void> {
    return this.http.put<void>(this.baseUrl, markNotificationAsDelivered);
  }

  deleteNotification(notificationId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${notificationId}`);
  }

  getNotificationsForUser(filter: GetAllNotificationsForUserFilter): Observable<NotificationForUser[]> {
    const params = filter.toQueryParams();
    return this.http.get<NotificationForUser[]>(`${this.baseUrl}`, { params });
  }

  getUnreadNotificationsForUser(filter: GetUnreadNotificationsForUserFilter): Observable<UnreadNotificationForUser[]> {
    const params = filter.toQueryParams();
    return this.http.get<UnreadNotificationForUser[]>(`${this.baseUrl}/unread`, { params });
  }

  getNotificationsCreatedByUser(filter: GetNotificationsCreatedByUserFilter): Observable<NotificationCreatedByUser[]> {
    const params = filter.toQueryParams();
    return this.http.get<NotificationCreatedByUser[]>(`${this.baseUrl}/created`, { params });
  }
}